export default __webpack_public_path__ + "static/prodocs-logo-e74eaa2b08591d3c7e586c7b84012e0a.png";